import { ReactNode } from 'react';
import './migration.css';

export default function MigrationDetails({ title, children, open = false }: {
  title: string; children: ReactNode; open?: boolean;
}) {
  return <details className="migration-details" open={open || undefined}>
    <summary>{title}</summary>
    <div className="migration-details-content">{children}</div>
  </details>;
}
